type StatusKind = 'ok' | 'warn' | 'err' | 'info' | 'muted';

const CLASSES: Record<StatusKind, string> = {
  ok: 'st st-ok',
  warn: 'st st-warn',
  err: 'st st-err',
  info: 'st st-info',
  muted: 'st st-muted',
};

export function Status({ kind, children }: { kind: StatusKind; children: React.ReactNode }) {
  return <span className={CLASSES[kind]}>{children}</span>;
}

export function statusKindForJobStatus(s: string | null | undefined): StatusKind {
  switch (s) {
    case 'sent':
    case 'succeeded':
    case 'processed':
    case 'received':
      return 'ok';
    case 'pending':
    case 'in_progress':
    case 'processing':
    case 'running':
    case 'idle':
      return 'info';
    case 'failed':
    case 'duplicate':
      return 'warn';
    case 'dead_letter':
      return 'err';
    default:
      return 'muted';
  }
}
